export enum EnumEstadoProductoCapacidad {
  Analizada = 1,
  Anulada = 2,
  CapacidadDefinitivaAsignada = 3,
  CapacidadProvisionalAsignada = 4,
  Formalizada = 5,
  NoAprobado = 6,
  Rechazada = 7,
  Registrada = 8,
  Borrador = 9,
  Solicitado = 10,
  Aceptado = 12,
  Activo = 14,
  Baja = 15,
  PendienteModificacion = 16
}
